import _ from 'lodash';
import React, { useMemo } from 'react';
import {
  DisciplineFilter,
  EmploymentTypeFilter,
  JobTitleFilter,
  MemberLevelFilter,
  LocationFilter,
  MemberBillableTypeFilter,
  MemberCostMethodFilter,
  MemberFilter,
  MemberInvitationStatusFilter,
  MemberStatusFilter,
  MemberTagFilter,
  PracticeFilter,
  SecurityRoleFilter,
  SkillFilter,
} from '~/components';
import ReportPeriodFilter from './ReportPeriodFilter';
import { useFeatures } from '~/hooks';

function MemberFiltersBar({ filters, sticky, onChange }) {
  const features = useFeatures();

  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      members: isVisible('members'),
      memberEmploymentTypes: isVisible('memberEmploymentTypes'),
      memberBillableTypeId: isVisible('memberBillableTypeId'),
      memberStatusId: isVisible('memberStatusId'),
      memberDisciplines: features.disciplines && isVisible('memberDisciplines'),
      memberJobTitles: isVisible('memberJobTitles'),
      memberLevels: isVisible('memberLevels'),
      memberPractices: features.practices && isVisible('memberPractices'),
      memberManagers: isVisible('memberManagers'),
      memberSkills: isVisible('memberSkills'),
      memberTags: isVisible('memberTags'),
      memberLocations: isVisible('memberLocations'),
      memberSecurityRoles: isVisible('memberSecurityRoles'),
      memberCostMethods: isVisible('memberCostMethods'),
      memberInvitationStatuses: isVisible('memberInvitationStatuses'),
      memberActivePeriod:
        sticky?.includes('memberActivePeriod') ||
        Boolean(filters.memberActivePeriod?.start || filters.memberActivePeriod?.end),
    };
  }, [filters, sticky, features]);

  return (
    <>
      {visible.members && (
        <MemberFilter value={filters.members} onChange={({ value }) => onChange({ members: value })} />
      )}

      {visible.memberSecurityRoles && (
        <SecurityRoleFilter
          placeholder="Member Security Role"
          value={filters.memberSecurityRoles}
          onChange={({ value }) => onChange({ memberSecurityRoles: value })}
        />
      )}

      {visible.memberEmploymentTypes && (
        <EmploymentTypeFilter
          value={filters.memberEmploymentTypes}
          onChange={({ value }) => onChange({ memberEmploymentTypes: value })}
        />
      )}

      {visible.memberBillableTypeId && (
        <MemberBillableTypeFilter
          value={filters.memberBillableTypeId}
          onChange={({ value }) => onChange({ memberBillableTypeId: value })}
        />
      )}

      {visible.memberStatusId && (
        <MemberStatusFilter
          placeholder="Member Status"
          value={filters.memberStatusId}
          onChange={({ value }) => onChange({ memberStatusId: value })}
        />
      )}

      {visible.memberDisciplines && (
        <DisciplineFilter
          placeholder="Member Discipline"
          value={filters.memberDisciplines}
          onChange={({ value }) => onChange({ memberDisciplines: value })}
        />
      )}

      {visible.memberJobTitles && (
        <JobTitleFilter
          value={filters.memberJobTitles}
          onChange={({ value }) => onChange({ memberJobTitles: value })}
        />
      )}

      {visible.memberLevels && (
        <MemberLevelFilter value={filters.memberLevels} onChange={({ value }) => onChange({ memberLevels: value })} />
      )}

      {visible.memberPractices && (
        <PracticeFilter
          placeholder="Member Practice"
          value={filters.memberPractices}
          onChange={({ value }) => onChange({ memberPractices: value })}
        />
      )}

      {visible.memberManagers && (
        <MemberFilter
          placeholder="Member Manager"
          value={filters.memberManagers}
          onChange={({ value }) => onChange({ memberManagers: value })}
        />
      )}

      {visible.memberSkills && (
        <SkillFilter
          placeholder="Member Skills"
          value={filters.memberSkills}
          onChange={({ value }) => onChange({ memberSkills: value })}
        />
      )}

      {visible.memberTags && (
        <MemberTagFilter value={filters.memberTags} onChange={({ value }) => onChange({ memberTags: value })} />
      )}

      {visible.memberCostMethods && (
        <MemberCostMethodFilter
          value={filters.memberCostMethods}
          onChange={({ value }) => onChange({ memberCostMethods: value })}
        />
      )}

      {visible.memberLocations && (
        <LocationFilter
          placeholder="Member Location"
          value={filters.memberLocations}
          onChange={({ value }) => onChange({ memberLocations: value })}
        />
      )}

      {visible.memberInvitationStatuses && (
        <MemberInvitationStatusFilter
          value={filters.memberInvitationStatuses}
          onChange={({ value }) => onChange({ memberInvitationStatuses: value })}
        />
      )}

      {visible.memberActivePeriod && (
        <ReportPeriodFilter
          placeholder="Member Active Range"
          value={filters.memberActivePeriod}
          onChange={({ value }) => onChange({ memberActivePeriod: value })}
        />
      )}
    </>
  );
}

export default MemberFiltersBar;
